import React from "react";
import Processes from "./Processes";
export default function AccountIntegration() {
  return (
    <div>
      <Processes />
    </div>
  );
}
